import { useMsal } from "@azure/msal-react";
import axios from "axios";
import {useEffect, useState} from "react";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


export const MicrosoftAuth = () => {
    const { instance } = useMsal();
    const [authError, setAuthError] = useState<string | null>(null);

    useEffect(() => {
        console.log("MicrosoftAuth component re-rendered");
    });

    const handleInteractiveSignIn = async () => {
        try {

            console.log("Attempting Auth");

            const loginResponse = await instance.loginPopup({
                scopes: ["User.Read", "openid", "email"]
            });

            const idToken = loginResponse.idToken;

            const endpoint = `${REACT_APP_API_URL}/api/v1.0/desktop/account`;

            const response = await axios.get(endpoint, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`,
                }
            });

            const userData = response.data.value;

            localStorage.setItem('subjectToken', loginResponse.idToken);
            localStorage.setItem('accessToken', loginResponse.accessToken);


            localStorage.setItem('userEmail', userData.email);
            localStorage.setItem('userName', userData.name);
            localStorage.setItem('role', userData.role);

            localStorage.setItem('isSentimentEnabled', userData.subscription?.isSentimentEnabled);
            localStorage.setItem('isTeamsEnabled', userData.subscription?.isTeamsEnabled);
            localStorage.setItem('isOutlookEnabled', userData.subscription?.isOutlookEnabled);
            localStorage.setItem('isWordEnabled', userData.subscription?.isWordEnabled);

            localStorage.setItem('cancelled', userData.subscription?.cancelled);

            localStorage.setItem('numberOfSeats', userData.numberOfSeats);
            localStorage.setItem('subscriptionType', userData.subscriptionType);
            localStorage.setItem('paid', userData.subscription.paid);
            localStorage.setItem('isChargebeePaid', userData.subscription.chargebeeIsPaid)


            const hasPassword = !!userData.password;
            localStorage.setItem('hasPassword', hasPassword.toString());
            return true;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error("Error during interactive authentication:", error.message);
                setAuthError(error.message);
            } else {
                console.error("Unexpected error:", error);
                setAuthError("An unexpected error occurred.");
            }
            return false;
        }
    };

    const microsoftAccountLink = async (linkIdentifier: string | null) => {
        try {
            const loginResponse = await instance.loginPopup({
                scopes: ["User.Read", "openid"]
            });

            const idToken = loginResponse.idToken;

            const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/account/link';

            const headers: any = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
                'link' : linkIdentifier
            };

            if (linkIdentifier) {
                headers['link'] = linkIdentifier;
            }

            const response = await axios.get(endpoint, {
                headers: headers
            });

            const userData = response.data.value;

            localStorage.setItem('userEmail', userData.email);
            localStorage.setItem('userName', userData.name);
            localStorage.setItem('role', userData.role);

            localStorage.setItem('isSentimentEnabled', userData.subscription?.isSentimentEnabled);
            localStorage.setItem('isTeamsEnabled', userData.subscription?.isTeamsEnabled);
            localStorage.setItem('isOutlookEnabled', userData.subscription?.isOutlookEnabled);
            localStorage.setItem('isWordEnabled', userData.subscription?.isWordEnabled);

            localStorage.setItem('numberOfSeats', userData.numberOfSeats);
            localStorage.setItem('subscriptionType', userData.subscriptionType);
            localStorage.setItem('paid', userData.subscription.paid);
            localStorage.setItem('isChargebeePaid', userData.subscription.chargebeeIsPaid)


            localStorage.setItem('subjectToken', loginResponse.idToken);
            localStorage.setItem('accessToken', loginResponse.accessToken);


            const hasPassword = !!userData.password;
            localStorage.setItem('hasPassword', hasPassword.toString());
            return true;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error("Error during interactive authentication:", error.message);
                setAuthError(error.message);
            } else {
                console.error("Unexpected error:", error);
                setAuthError("An unexpected error occurred.");
            }
            return false;
        }
    };


    return { handleInteractiveSignIn, microsoftAccountLink, authError };
};
